import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Y si sí tuve parte de culpa?',
    a: 'Parte de culpa en problemas de pareja no es lo mismo que responsabilidad por traicionar.'
  }, {
    q: '¿Y si me quedo?',
    a: 'Quedarte puede ser válido. Lo que no es válido es desaparecerte.'
  }, {
    q: '¿Y si me voy?',
    a: 'Te vas con plan, no con pánico. Este protocolo te ayuda a sostenerte.'
  }];
  return <section className="bg-white px-6 py-16 md:py-24" data-id="element-44">
      <div className="mx-auto max-w-2xl" data-id="element-45">
        <h2 className="mb-10 text-center text-3xl font-bold text-[#2D2420] md:text-4xl" data-id="element-46">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-47">
          {faqs.map((faq, i) => <div key={i} className="overflow-hidden rounded-lg border border-[#E8DDD4] bg-[#FFFBF5] transition-all hover:border-[#C4704B]" data-id="element-48">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="flex w-full items-center justify-between p-6 text-left focus:outline-none" data-id="element-49">
                <span className="font-serif text-lg font-bold text-[#2D2420]" data-id="element-50">
                  {faq.q}
                </span>
                {openIndex === i ? <ChevronUp className="h-5 w-5 text-[#C4704B]" data-id="element-51" /> : <ChevronDown className="h-5 w-5 text-[#8B7D75]" data-id="element-52" />}
              </button>

              {openIndex === i && <div className="border-t border-[#E8DDD4] bg-white p-6 text-[#2D2420]" data-id="element-53">
                  <p data-id="element-54">{faq.a}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}